import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import Grid from "@mui/material/Grid";
import React from "react";
import Group from "@/src/components/Wizard/Group";
import { requiredValidator } from "@/src/services/validationRules";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type ClientAgreesProps = {
  product: AbstractCase;
  question?: string;
  hintText?: string;
};

const ClientAgrees = ({
  product,
  question = "Ist die Reaktion der Gegenseite für Sie zufriedenstellend?",
  hintText = "Hier geht es zunächst nur darum, dass die Reaktion der Gegenseite in Ihrem Sinne ist. Sollten noch Einzelheiten zur vollständigen Abwicklung des Falls zwischen Ihnen und der Gegenseite geklärt werden müssen, können Sie dies natürlich noch im Nachgang tun.",
}: ClientAgreesProps) => {
  if (product.extrajudicialReaction !== "fullyAgreed") {
    return null;
  }

  return (
    <Grid size={12}>
      <Group
        type={"radio"}
        name={"clientAgrees"}
        question={question}
        options={[
          {
            labelText: "Ja",
            labelIcon: <CheckIcon />,
            labelIconActive: <CheckIcon active />,
            value: "yes",
            optionHintText: hintText,
          },
          {
            labelText: "Nein",
            labelIcon: <CrossIcon />,
            labelIconActive: <CrossIcon active />,
            value: "no",
          },
        ]}
        validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
      />
    </Grid>
  );
};
export default ClientAgrees;
